import Manager from '../../api/Manager';

export default async (to, from, next) => {
  try {
    let clientId = to && to.params && to.params.clientId
        ? parseInt(to.params.clientId)
        : null;
    let response = await Manager.hasAccess(clientId);
    let {data: result} = response.data;
    if (result && result.hasAccess) {
      next();
    } else {
      throw new Error('Forbidden');
    }
  } catch (e) {
    next({name: 'default'});
  }
};


// WEBPACK FOOTER //
// ./src/modules/randomRotation/routes/hooks/hasAccess.js